/**
 * Конвертирует булево значение в строковое значение
 * @param value Исходное булево значение
 * @param trueValue Результат, если {@link value} истинно
 * @param falseValue Результат, если {@link value} ложно
 */
export const boolToString = (value: boolean, trueValue: string = "Да", falseValue: string = "Нет") => {
  return value
    ? trueValue
    : falseValue;
}



// WEBPACK FOOTER //
// ./src/app/core/utils/convert.ts